module.exports = __webpack_public_path__ + "img/type5.b7161e7c.png";